/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { consultationAdminControllerCreateMemoV1 } from '../fn/consultation-admin/consultation-admin-controller-create-memo-v-1';
import { ConsultationAdminControllerCreateMemoV1$Params } from '../fn/consultation-admin/consultation-admin-controller-create-memo-v-1';
import { consultationAdminControllerDeleteMemoV1 } from '../fn/consultation-admin/consultation-admin-controller-delete-memo-v-1';
import { ConsultationAdminControllerDeleteMemoV1$Params } from '../fn/consultation-admin/consultation-admin-controller-delete-memo-v-1';
import { consultationAdminControllerDeleteV1 } from '../fn/consultation-admin/consultation-admin-controller-delete-v-1';
import { ConsultationAdminControllerDeleteV1$Params } from '../fn/consultation-admin/consultation-admin-controller-delete-v-1';
import { consultationAdminControllerFindByIdV1 } from '../fn/consultation-admin/consultation-admin-controller-find-by-id-v-1';
import { ConsultationAdminControllerFindByIdV1$Params } from '../fn/consultation-admin/consultation-admin-controller-find-by-id-v-1';
import { consultationAdminControllerSearchV1 } from '../fn/consultation-admin/consultation-admin-controller-search-v-1';
import { ConsultationAdminControllerSearchV1$Params } from '../fn/consultation-admin/consultation-admin-controller-search-v-1';
import { consultationAdminControllerUpdateMemoV1 } from '../fn/consultation-admin/consultation-admin-controller-update-memo-v-1';
import { ConsultationAdminControllerUpdateMemoV1$Params } from '../fn/consultation-admin/consultation-admin-controller-update-memo-v-1';
import { consultationAdminControllerUpdateStatusV1 } from '../fn/consultation-admin/consultation-admin-controller-update-status-v-1';
import { ConsultationAdminControllerUpdateStatusV1$Params } from '../fn/consultation-admin/consultation-admin-controller-update-status-v-1';
import { ConsultationDto } from '../models/consultation-dto';
import { ConsultationMemoResponseDto } from '../models/consultation-memo-response-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class ConsultationAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `consultationAdminControllerSearchV1()` */
  static readonly ConsultationAdminControllerSearchV1Path = '/api/v1/consultations/admin';

  /**
   * 상담 문의 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consultationAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  consultationAdminControllerSearchV1$Response(params: ConsultationAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ConsultationDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = consultationAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상담 문의 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consultationAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consultationAdminControllerSearchV1(params: ConsultationAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<ConsultationDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.consultationAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<ConsultationDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<ConsultationDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `consultationAdminControllerFindByIdV1()` */
  static readonly ConsultationAdminControllerFindByIdV1Path = '/api/v1/consultations/admin/{id}';

  /**
   * 상담 문의 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consultationAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  consultationAdminControllerFindByIdV1$Response(params: ConsultationAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationDto>> {
    const obs = consultationAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상담 문의 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consultationAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consultationAdminControllerFindByIdV1(params: ConsultationAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<ConsultationDto> {
    const resp = this.consultationAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConsultationDto>): ConsultationDto => r.body)
    );
  }

  /** Path part for operation `consultationAdminControllerDeleteV1()` */
  static readonly ConsultationAdminControllerDeleteV1Path = '/api/v1/consultations/admin/{id}';

  /**
   * 상담 문의 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consultationAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  consultationAdminControllerDeleteV1$Response(params: ConsultationAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = consultationAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상담 문의 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consultationAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consultationAdminControllerDeleteV1(params: ConsultationAdminControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.consultationAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `consultationAdminControllerUpdateStatusV1()` */
  static readonly ConsultationAdminControllerUpdateStatusV1Path = '/api/v1/consultations/admin/{id}/status';

  /**
   * 상담 문의 상태 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consultationAdminControllerUpdateStatusV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  consultationAdminControllerUpdateStatusV1$Response(params: ConsultationAdminControllerUpdateStatusV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = consultationAdminControllerUpdateStatusV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상담 문의 상태 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consultationAdminControllerUpdateStatusV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  consultationAdminControllerUpdateStatusV1(params: ConsultationAdminControllerUpdateStatusV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.consultationAdminControllerUpdateStatusV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `consultationAdminControllerCreateMemoV1()` */
  static readonly ConsultationAdminControllerCreateMemoV1Path = '/api/v1/consultations/admin/{id}/memos';

  /**
   * 상담 메모 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consultationAdminControllerCreateMemoV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  consultationAdminControllerCreateMemoV1$Response(params: ConsultationAdminControllerCreateMemoV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationMemoResponseDto>> {
    const obs = consultationAdminControllerCreateMemoV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상담 메모 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consultationAdminControllerCreateMemoV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  consultationAdminControllerCreateMemoV1(params: ConsultationAdminControllerCreateMemoV1$Params, context?: HttpContext): Observable<ConsultationMemoResponseDto> {
    const resp = this.consultationAdminControllerCreateMemoV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConsultationMemoResponseDto>): ConsultationMemoResponseDto => r.body)
    );
  }

  /** Path part for operation `consultationAdminControllerDeleteMemoV1()` */
  static readonly ConsultationAdminControllerDeleteMemoV1Path = '/api/v1/consultations/admin/{id}/memos/{memoId}';

  /**
   * 상담 메모 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consultationAdminControllerDeleteMemoV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  consultationAdminControllerDeleteMemoV1$Response(params: ConsultationAdminControllerDeleteMemoV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = consultationAdminControllerDeleteMemoV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상담 메모 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consultationAdminControllerDeleteMemoV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consultationAdminControllerDeleteMemoV1(params: ConsultationAdminControllerDeleteMemoV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.consultationAdminControllerDeleteMemoV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `consultationAdminControllerUpdateMemoV1()` */
  static readonly ConsultationAdminControllerUpdateMemoV1Path = '/api/v1/consultations/admin/{id}/memos/{memoId}';

  /**
   * 상담 메모 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consultationAdminControllerUpdateMemoV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  consultationAdminControllerUpdateMemoV1$Response(params: ConsultationAdminControllerUpdateMemoV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationMemoResponseDto>> {
    const obs = consultationAdminControllerUpdateMemoV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상담 메모 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consultationAdminControllerUpdateMemoV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  consultationAdminControllerUpdateMemoV1(params: ConsultationAdminControllerUpdateMemoV1$Params, context?: HttpContext): Observable<ConsultationMemoResponseDto> {
    const resp = this.consultationAdminControllerUpdateMemoV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConsultationMemoResponseDto>): ConsultationMemoResponseDto => r.body)
    );
  }

}
